import { useState, type FormEvent } from 'react';
import {
  Alert,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : 'Не удалось связаться с сервером. Проверьте, запущен ли API.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <Center mih="100vh" bg="var(--mantine-color-gray-0)">
      <Paper shadow="sm" radius="md" p="xl" w={400} withBorder>
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <div>
              <Title order={2}>ERP-complete</Title>
              <Text c="dimmed" size="sm" mt={4}>
                Вход в систему
              </Text>
            </div>

            {error && (
              <Alert color="red" icon={<IconAlertCircle size={18} />} variant="light">
                {error}
              </Alert>
            )}

            <TextInput
              label="Электронная почта"
              placeholder="user@company.ru"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              required
              autoFocus
              autoComplete="username"
            />

            <PasswordInput
              label="Пароль"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              required
              autoComplete="current-password"
            />

            <Button type="submit" loading={busy} fullWidth mt="xs">
              Войти
            </Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
